import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3977cb58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"clear":"both"} }
const _hoisted_2 = { class: "log-header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "log" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  key: 4,
  class: "new-value full"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 5,
  class: "old-value full"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "from" }, "从值", -1))
const _hoisted_16 = { class: "old-value" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "to" }, "改为", -1))
const _hoisted_20 = { class: "new-value" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_miezz_card = _resolveComponent("miezz-card")!

  return (_openBlock(), _createBlock(_component_miezz_card, {
    title: "历史记录",
    style: {"margin-top":"10px"},
    toggle: true,
    down: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          style: _normalizeStyle(_ctx.isShow == true ? 'width: calc(100% - 130px); padding-left:130px' : 'wdith:100%;')
        }, [
          _createVNode(_component_el_timeline, { style: {"width":"calc(100% - 40px)"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (item, i) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: i,
                  timestamp: _ctx.handleDateFormat(item.CreatedTime),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createTextVNode(" 由 " + _toDisplayString(item.CreatedUserName), 1),
                      (item.CreatedCompanyNameZh)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "（" + _toDisplayString(item.CreatedCompanyNameZh) + "）", 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString(item.Title), 1)
                    ]),
                    ((item.Changes?.length ?? 0) > 0)
                      ? (_openBlock(), _createBlock(_component_el_tree, {
                          key: 0,
                          ref_for: true,
                          ref: "treeRef",
                          "node-key": "Id",
                          data: item.Changes,
                          props: _ctx.props,
                          load: _ctx.loadNode,
                          lazy: ""
                        }, {
                          default: _withCtx(({ data, node }) => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("span", {
                                class: "label",
                                style: _normalizeStyle(`width: ${_ctx.labelWidth ?? '160px'}`)
                              }, _toDisplayString(data.Label), 5),
                              (data.Title)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(data.Title), 1))
                                : (data.State == _ctx.UiHistoryState.Added)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "新增"))
                                  : (data.State == _ctx.UiHistoryState.Deleted)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "删除"))
                                    : (data.State == _ctx.UiHistoryState.Modified)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "编辑"))
                                      : (node.parent.data.State == _ctx.UiHistoryState.Added)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                            _createVNode(_component_el_tooltip, {
                                              effect: "dark",
                                              content: data.NewValue,
                                              placement: "top",
                                              "popper-class": "tool-tip1"
                                            }, {
                                              default: _withCtx(() => [
                                                (data.Pipe == 'File' && data.NewValue)
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 0,
                                                      target: "_blank",
                                                      href: _ctx.hnadleGetUrl(data.NewValue)
                                                    }, _toDisplayString(_ctx.handleFileFormat(data.NewValue)), 9, _hoisted_10))
                                                  : (_openBlock(), _createElementBlock("pre", _hoisted_11, _toDisplayString(data.NewValue ? data.NewValue : "暂无数据"), 1))
                                              ]),
                                              _: 2
                                            }, 1032, ["content"])
                                          ]))
                                        : (
                      node.parent.data.State == _ctx.UiHistoryState.Deleted ||
                      item.State == _ctx.UiHistoryState.Deleted
                    )
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                              _createVNode(_component_el_tooltip, {
                                                effect: "dark",
                                                content: data.OldValue,
                                                placement: "top",
                                                "popper-class": "tool-tip1"
                                              }, {
                                                default: _withCtx(() => [
                                                  (data.Pipe == 'File' && data.OldValue)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        target: "_blank",
                                                        href: _ctx.hnadleGetUrl(data.OldValue)
                                                      }, _toDisplayString(_ctx.handleFileFormat(data.OldValue)), 9, _hoisted_13))
                                                    : (_openBlock(), _createElementBlock("pre", _hoisted_14, _toDisplayString(data.OldValue ? data.OldValue : "暂无数据"), 1))
                                                ]),
                                                _: 2
                                              }, 1032, ["content"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", {
                                              key: 6,
                                              class: "change",
                                              style: _normalizeStyle(`width: calc(100% - ${
                      _ctx.labelWidth ?? '160px'
                    } - 5px)`)
                                            }, [
                                              _hoisted_15,
                                              _createElementVNode("span", _hoisted_16, [
                                                _createVNode(_component_el_tooltip, {
                                                  effect: "dark",
                                                  content: data.OldValue,
                                                  placement: "top",
                                                  "popper-class": "tool-tip1"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (data.Pipe == 'File' && data.OldValue)
                                                      ? (_openBlock(), _createElementBlock("a", {
                                                          key: 0,
                                                          target: "_blank",
                                                          href: _ctx.hnadleGetUrl(data.OldValue)
                                                        }, _toDisplayString(_ctx.handleFileFormat(data.OldValue)), 9, _hoisted_17))
                                                      : (_openBlock(), _createElementBlock("pre", _hoisted_18, _toDisplayString(data.OldValue ? data.OldValue : "暂无数据"), 1))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["content"])
                                              ]),
                                              _hoisted_19,
                                              _createElementVNode("span", _hoisted_20, [
                                                _createVNode(_component_el_tooltip, {
                                                  effect: "dark",
                                                  content: data.NewValue,
                                                  placement: "top",
                                                  "popper-class": "tool-tip1"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (data.Pipe == 'File' && data.NewValue)
                                                      ? (_openBlock(), _createElementBlock("a", {
                                                          key: 0,
                                                          target: "_blank",
                                                          href: _ctx.hnadleGetUrl(data.NewValue)
                                                        }, _toDisplayString(_ctx.handleFileFormat(data.NewValue)), 9, _hoisted_21))
                                                      : (_openBlock(), _createElementBlock("pre", _hoisted_22, _toDisplayString(data.NewValue ? data.NewValue : "暂无数据"), 1))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["content"])
                                              ])
                                            ], 4))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["data", "props", "load"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["timestamp"]))
              }), 128))
            ]),
            _: 1
          })
        ], 4)
      ])
    ]),
    _: 1
  }))
}